import React from "react";
import {DropdownMenuItem} from "@reside/ui";

import {
  AdmissionFromSearch,
  downloadAdmissionPdf,
} from "../../../../../services/AdmissionsService";
import {getResidentTestId} from "../../../helper";
import {useDownloadManager} from "../../../../../hooks/useDownloadManager";

export const DownloadPartialPDFDropdownItem = ({
  admission,
  ...props
}: {
  admission: AdmissionFromSearch;
}) => {
  const {start} = useDownloadManager();

  return (
    <>
      {admission.resources?.partialPdfs?.map(({group}) => (
        <DropdownMenuItem
          key={group}
          onClick={() => {
            start(`Download ${group}`, () =>
              downloadAdmissionPdf({
                admissionId: admission.id,
                type: "partial",
                group,
              }),
            );
          }}
          testId={getResidentTestId(admission, `downloadPdf-${group}`)}
          {...props}
        >
          Download {group}
        </DropdownMenuItem>
      ))}
    </>
  );
};
